import React, { useRef, useState, useEffect } from "react"
import "ol/ol.css"
import "../css/map.css"
import MapContext from "./MapContext"
import * as ol from "ol"
import * as olControl from "ol/control"


const Map = ({ children, zoom, center }) => {
  const mapRef = useRef();
  const [map, setMap] = useState(null);
  // on component mount
  useEffect(() => {
    let options = {
      view: new ol.View({ zoom, center }),
      layers: [],
      controls: [new olControl.Attribution({ collapsible: true, collapsed: false })],
      overlays: []
    };
    let mapObject = new ol.Map(options);
    mapObject.setTarget(mapRef.current);
    setMap(mapObject);
    // Keep the map crisp while its container resizes (splitter drags, mode
    // switches) — OpenLayers only re-measures on explicit updateSize calls.

    const el = mapRef.current
    const updateSize = () => {
      if (mapObject.updateSize) mapObject.updateSize()
    }
    let ro = null
    if (typeof ResizeObserver !== 'undefined' && el) {
      ro = new ResizeObserver(updateSize)
      ro.observe(el)
    }
    return () => {
      if (ro) ro.disconnect()
      mapObject.setTarget(undefined);
    };
  }, [zoom, center]);
  // zoom change handler
  useEffect(() => {
    if (!map) return;
    map.getView().setZoom(zoom);
  }, [zoom, map]);
  // center change handler
  useEffect(() => {
    if (!map) return;
    map.getView().setCenter(center)
  }, [center, map])
  return (
    <MapContext.Provider value={{ map }}>
      <div ref={mapRef} className="ol-map">
        {children}
      </div>
    </MapContext.Provider>
  )
}
export default Map;